<ng-container *mpHeaderElement="'left'">
  <mp-root-module-nav label="Benutzer" />
</ng-container>

<mpk-users-list-view [users]="users()" [usersLoaded]="usersLoaded()" (loadUsers)="loadUsers($event)" />
<!-- TODO: Add export button here to match previous behavior -->
